import {Chat} from '../../../chats/chat';
import {useTrans} from '@common/i18n/use-trans';
import {useNavigate} from '@common/utils/hooks/use-navigate';
import {useMutation} from '@tanstack/react-query';
import {toast} from '@common/ui/toast/toast';
import {message} from '@common/i18n/message';
import {apiClient, queryClient} from '@common/http/query-client';
import {DatatableDataQueryKey} from '@common/datatable/requests/paginated-resources';
import {onFormQueryError} from '@common/errors/on-form-query-error';
import {UseFormReturn} from 'react-hook-form';

const endpoint = 'chats';

export function useCreateChat(form: UseFormReturn<Chat>, callback_url: string) {
  const {trans} = useTrans();
  const navigate = useNavigate();
  return useMutation({
    mutationFn: (payload: Chat) => createChat(payload),
    onSuccess: () => {
      toast(trans(message('Chat created')));
      queryClient.invalidateQueries({queryKey: [endpoint]});
      queryClient.invalidateQueries({queryKey: ['my-chats']});
      queryClient.invalidateQueries({
        queryKey: DatatableDataQueryKey('chats'),
      });
      navigate(callback_url ? callback_url : '/admin/chats');
    },
    onError: err => onFormQueryError(err, form),
  });
}

function createChat(payload: Chat): Promise<Response> {
  const backendPayload = {
    ...payload
  };
  return apiClient.post(endpoint, backendPayload).then(r => r.data);
}
